import DesktopTrending from './'

const TrendingRoute = () => <DesktopTrending />

export default TrendingRoute
